import Service from "../../Services";

const Members = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title_th : '',
      title_en : '',
      detail_en : '',
      detail_th : '',
      slug_url : '',
      is_publish : true,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        detail_en : '',
        detail_th : '',
        slug_url : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getMembers({commit},page){
      return Service.MembersAPI.getMembers(page);
    },
    showMembers({commit},id){
      return Service.MembersAPI.showMembers(id);
    },
    saveMembers({commit},{id,data}){
      if(id){
        return Service.MembersAPI.updateMembers(id,data);
      }else{
        return Service.MembersAPI.createMembers(data);
      }
    },
    deleteMembers({commit},id){
      return Service.MembersAPI.deleteMembers(id);
    },
    setFormMembers({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Members
